import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgAssetInventory = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M14.75 0.25H1.25V11.75H10.25V13.25H0.5V14.75H10.25V17.75H17.75V6.25H14.75V0.25ZM10.25 6.25V10.25H2.75V1.75H13.25V6.25H10.25ZM11.75 7.75V16.25H16.25V7.75H11.75Z"
	})
});
export default SvgAssetInventory;
